import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

export default function CompletionRateByQuestion({ data }) {
  const chartData = (data.questions || []).map(q => ({
    name: q.question_text?.slice(0, 50) || `Q${q.position}`,
    fullName: q.question_text,
    rate: Math.round((q.completion_rate || 0) * 100),
  }));

  return (
    <div>
      <h3>Completion Rate by Question</h3>
      <ResponsiveContainer width="100%" height={Math.max(200, chartData.length * 50)}>
        <BarChart data={chartData} layout="vertical" margin={{ left: 160, right: 30, top: 10, bottom: 10 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" domain={[0, 100]} tickFormatter={v => `${v}%`} />
          <YAxis type="category" dataKey="name" width={150} />
          <Tooltip formatter={(v) => [`${v}%`, 'Completion Rate']} />
          <Bar dataKey="rate">
            {chartData.map((entry, i) => (
              <Cell key={i} fill={entry.rate < 70 ? '#f59e0b' : '#3b82f6'} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
